import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { Switch } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

import { Toast } from "primereact/toast";
import { AppFooter } from "./AppFooter";
import { AppMenu } from "./AppMenu";
import { AppProfile } from "./AppProfile";
import { AppTopbar } from "./AppTopbar";

//PAGINAS
import Login from "./pages/login";

// import { AppConfig } from './AppConfig';

import { useSelector } from "react-redux";

// import PrimeReact from 'primereact/utils';

import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "prismjs/themes/prism-coy.css";
import "./App.scss";
import "./assets/css/layout.scss";

import logo from "./assets/img/seplagmini.png";
import Loader from "./components/Loader";
import api from "./config/axios";
import Menu from "./config/menu";

// import { addLocale } from 'primereact/api';

import { Link } from "react-router-dom";
import Router from "./config/router";

const App = () => {
  const user = useSelector((state) => state.userReducer.user);
  window.$http = api();
  window.$toast = useRef(null);

  const [layoutMode, setLayoutMode] = useState("static");
  const [layoutColorMode, setLayoutColorMode] = useState("dark");
  const [staticMenuInactive, setStaticMenuInactive] = useState(false);
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [exibirModalTrocaSenha, setExibirModalTrocaSenha] = useState(false);
  const [versaoAPI, setVersaoAPI] = useState("");
  const [inputStyle] = useState("outlined");
  const [ripple] = useState(false);
  const sidebar = useRef();
  let menuClick = false;

  useEffect(() => {
    if (user) {
      if (user.contaAcesso.trocarSenha === "S") {
      } else {
      }
    }
  }, [user]);

  useEffect(() => {
    window.$http.get(`publicos/sistemas/versao`).then((res) => {
      setVersaoAPI(res.data);
    });
  }, []);

  useEffect(() => {
    if (mobileMenuActive) {
      addClass(document.body, "body-overflow-hidden");
    } else {
      removeClass(document.body, "body-overflow-hidden");
    }
  }, [mobileMenuActive]);

  const onWrapperClick = (event) => {
    if (!menuClick) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }
    menuClick = false;
  };

  const onToggleMenu = (event) => {
    menuClick = true;

    if (isDesktop()) {
      if (layoutMode === "overlay") {
        setOverlayMenuActive((prevState) => !prevState);
      } else if (layoutMode === "static") {
        setStaticMenuInactive((prevState) => !prevState);
      }
    } else {
      setMobileMenuActive((prevState) => !prevState);
    }
    event.preventDefault();
  };

  const onSidebarClick = () => {
    menuClick = true;
  };

  const onMenuItemClick = (event) => {
    if (!event.item.items) {
      setOverlayMenuActive(false);
      setMobileMenuActive(false);
    }
  };

  const menu = Menu();

  const addClass = (element, className) => {
    if (element.classList) element.classList.add(className);
    else element.className += " " + className;
  };

  const removeClass = (element, className) => {
    if (element.classList) element.classList.remove(className);
    else
      element.className = element.className.replace(
        new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"),
        " "
      );
  };

  const isDesktop = () => {
    return window.innerWidth > 1024;
  };

  const isSidebarVisible = () => {
    if (isDesktop()) {
      if (layoutMode === "static") return !staticMenuInactive;
      else if (layoutMode === "overlay") return overlayMenuActive;
      else return true;
    }

    return mobileMenuActive;
  };

  const verificaUserLogado = () => {
    if (user) {
      return (
        <>
          <AppTopbar onToggleMenu={onToggleMenu} isSidebarVisible={isSidebarVisible()} />
          <CSSTransition
            className="layout-sidebar layout-sidebar-light"
            timeout={{ enter: 200, exit: 500 }}
            in={isSidebarVisible()}
            unmountOnExit
          >
            <div ref={sidebar} className={sidebarClassName} onClick={onSidebarClick}>
              <div className="layout-logo">
                <Link to="/">
                  <img alt="Logo" src={logo} style={{ cursor: "pointer" }} />
                </Link>
              </div>
              <AppProfile />
              <AppMenu model={menu} onMenuItemClick={onMenuItemClick} />
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  top: "20px",
                  color: "rgb(255, 255, 255)",
                  flex: "1",
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                }}
              >
                {process.env.REACT_APP_VERSAO_FRONT} - {versaoAPI}
              </div>
            </div>
          </CSSTransition>
          <div className="layout-main">
            <Switch>
              <Router />
            </Switch>
          </div>
          <AppFooter />
        </>
      );
    } else {
      return <Login />;
    }
  };

  const wrapperClass = classNames("layout-wrapper", {
    "layout-overlay": layoutMode === "overlay",
    "layout-static": layoutMode === "static",
    "layout-static-sidebar-inactive": staticMenuInactive && layoutMode === "static",
    "layout-overlay-sidebar-active": overlayMenuActive && layoutMode === "overlay",
    "layout-mobile-sidebar-active": mobileMenuActive,
    "p-input-filled": inputStyle === "filled",
    "p-ripple-disabled": ripple === false,
  });

  const sidebarClassName = classNames("layout-sidebar", {
    "layout-sidebar-dark": layoutColorMode === "dark",
    "layout-sidebar-light": layoutColorMode === "light",
  });

  return (
    <div className={wrapperClass} onClick={onWrapperClick}>
      <Toast ref={window.$toast}></Toast>
      <Loader />
      {verificaUserLogado()}
    </div>
  );
};

export default App;
